import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

var _types$SET_DESCRIPTIO;

import * as types from './types';
export default (_types$SET_DESCRIPTIO = {}, _defineProperty(_types$SET_DESCRIPTIO, types.SET_DESCRIPTION, function (state, payload) {
  var currentState = state;
  currentState.description = payload;
}), _defineProperty(_types$SET_DESCRIPTIO, types.RESET_SEARCH, function (state) {
  var currentState = state;
  currentState.total = null;
  currentState.products = null;
  currentState.description = null;
}), _defineProperty(_types$SET_DESCRIPTIO, types.SET_PRODUCTS, function (state, _ref) {
  var products = _ref.products,
      total = _ref.total;
  var currentState = state;
  currentState.total = total;
  currentState.products = products;
}), _defineProperty(_types$SET_DESCRIPTIO, types.APPEND_PRODUCTS, function (state, payload) {
  var currentState = state;
  var products = currentState.products.map(function (e) {
    return Object.assign(e, {
      old: true
    });
  });
  currentState.products = [].concat(_toConsumableArray(products), _toConsumableArray(payload));
}), _defineProperty(_types$SET_DESCRIPTIO, types.PREPEND_PRODUCTS, function (state, payload) {
  var currentState = state;
  var products = currentState.products.map(function (e) {
    return Object.assign(e, {
      old: true
    });
  });
  currentState.products = [].concat(_toConsumableArray(payload), _toConsumableArray(products));
}), _types$SET_DESCRIPTIO);